import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import questionsAdmin from '../../../../apis/admin/question';

type QuestionsListState = {
    questions: []
    isLoading: boolean
}

const initialState: QuestionsListState = {
    questions: [],
    isLoading: false,
};

export const getQuestionsDatas = createAsyncThunk(
    'Questions/Listquestionstate',
    async ({content, status, type}:{content: any, status: any, type: any}) => {
        const response: any = await questionsAdmin.getQuestionsData(content, status, type);
        return response?.data?.data?.payload
    }
)
export const questionslice = createSlice({
    name: 'Questionslist',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getQuestionsDatas.pending, (state) => {
                state.isLoading = false
                state.questions = []
            })
            .addCase(getQuestionsDatas.fulfilled, (state, action: any) => {
                state.isLoading = true
                state.questions = action.payload
            })
            .addCase(getQuestionsDatas.rejected, (state, action) => {
                state.isLoading = true
                state.questions = []
            });
    },
});

export default questionslice.reducer;